const { hostname } = window.location;
let domain = 'shop.hachettebookgroup.com';
let storefrontAccessToken = 'fdf7a12aac6fc02a21b014e8b569ad8a';
let productId = 7655547470002;
if (hostname === 'hbg-develop.go-vip.co' || hostname === 'hbglocal.vipdev.lndo.site') {
	domain = 'hbgusadev.myshopify.com/';
	storefrontAccessToken = '47e8b2f8bcd90ed1007965c47234e5e6';
	productId = 8250823901359;
}
const freeShippingAmt = 35.00;
// send non HBG domains to respective shopify domain aliases
/* const hasShopAlias = ['novelsuspects.com', 'moontravelguides.com', 'thenovl.com'];
const domainWithoutWWW = hostname.replace(/^www\./, '');
if (hasShopAlias.includes(domainWithoutWWW)) {
  domain = `shop.${domainWithoutWWW}`;
} */ 

const addToCartIsbns = Object.entries(window).filter(([key]) => key.startsWith('addToCart_')); // eslint-disable-line max-len
let addToCartButton = {};
let buttonText = '';

// Utility to find .checkoutId from localStorage

function getCartGidFromLocalStorage() {

  for (let i = 0; i < localStorage.length; i++) {

    const key = localStorage.key(i);

    if (key && key.endsWith('.checkoutId')) {

      return localStorage.getItem(key);

    }

  }

  return null;

}

// Main function

async function getCartItemsWithMeta() {

  const cartGid = getCartGidFromLocalStorage();

  if (!cartGid) {

    console.warn('Cart ID (checkoutId) not found.');

    return;

  }

  const query = `

    query GetCartItems($cartId: ID!) {

      cart(id: $cartId) {

        id

        lines(first: 50) {

          edges {

            node {

              id

              quantity

              cost {

                totalAmount {

                  amount

                  currencyCode

                }

              }

              merchandise {

                ... on ProductVariant {

                  id

                  title

                  price {

                    amount

                    currencyCode

                  }

                  product {

                    id

                    title

                    productType

                  }

                }

              }

            }

          }

        }

      }

    }

  `;

  const response = await fetch(`https://${domain}/api/2025-01/graphql.json`, {

    method: 'POST',

    headers: {

      'X-Shopify-Storefront-Access-Token': storefrontAccessToken,

      'Content-Type': 'application/json',

    },

    body: JSON.stringify({

      query,

      variables: {

        cartId: cartGid

      },

    }),

  });

  const data = await response.json();

  const items = data?.data?.cart?.lines?.edges || [];

	let currentTotalCost = 0;

	items.forEach(({ node }) => {

    const variant = node.merchandise;

    const product = variant.product;

    const cost = node.cost.totalAmount;

    const quantity = node.quantity;

	// if(product.productType === "Hardback" || product.productType === "Paperback") {

		currentTotalCost += parseFloat(cost.amount*quantity);

	// }


  if(items.length === 1 && ( product.productType === "Audiobook (via Podcast App)" || product.productType === "Audiobook (Via Podcast Player)") ){
		document.getElementById('freeShippingMsg').style.display = 'none';
	}

  else {
    document.getElementById('freeShippingMsg').style.display = 'block';
  }

  });
	var subTotalEl = document.querySelector('.shopify-buy__cart__subtotal__price');
	if(subTotalEl){
  //subTotalEl.innerHTML = currentTotalCost > 0 ? '$'+currentTotalCost.toFixed(2) : '$0.00';
	}
  //document.querySelector('.shopify-buy__cart__subtotal__price').innerHTML = "$" + currentTotalCost.toFixed(2
  return currentTotalCost;

}

async function freeShippingMessage(){

	const freeShippingAmt = 35.00;

	let currentTotalCost = await getCartItemsWithMeta();

	if (!currentTotalCost) {

    console.warn('Unable to calculate freeshipping without cart data.');

    return;

  }

	let freeShippingRemainingAmt = parseFloat(freeShippingAmt) - parseFloat(currentTotalCost);
  freeShippingRemainingAmt = freeShippingRemainingAmt.toFixed(2);

	let freeShippingMsg = '';

	if (freeShippingRemainingAmt > 0.00) {

		freeShippingMsg = `You are $${freeShippingRemainingAmt} away from free shipping!`;

	} else {

		freeShippingMsg = "You've got free shipping!";

	}
  document.getElementById('freeShippingMsg').innerHTML = freeShippingMsg;
}

/**
 * Get campaign params from URL
 * URL example: hachettebookgroup.com/contributor/author-name/?lens=
 * example&utm_source=test1&utm_medium=test2&utm_campaign=test3&
 * utm_content=test4&utm_term=test5#testanchor
 */
function getCampaignData(url) {
  const urlObj = new URL(url);
  return {
    name: urlObj.searchParams.get('utm_campaign'),
    source: urlObj.searchParams.get('utm_source'),
    medium: urlObj.searchParams.get('utm_medium'),
  };
}

/**
 * Set a single elem value of a Braze custom attribute of array 100
 */
function setBrazeSingleElemArrayCustomAttr(attrName, attrVal, sourceStr) {
  if (attrVal) {
    // eslint-disable-next-line no-undef
    braze.getUser().addToCustomAttributeArray(
      attrName,
      attrVal + sourceStr,
    );
  }
}

/**
   * Set Braze custom attributes of array 100
   */
function setBrazeArrayCustomAttr(attrName, attrVal, sourceStr, isAttrValArray = false) {
  if (isAttrValArray) {
    for (let i = 0; i < attrVal.length; i += 1) {
      setBrazeSingleElemArrayCustomAttr(attrName, attrVal[i], sourceStr);
    }
  } else {
    setBrazeSingleElemArrayCustomAttr(attrName, attrVal, sourceStr);
  }
}

function updateCartCount(cart) {
  var total_cart_items = 0;
  var cart_total = 0;
  var cartCount = cart.lineItems.length;
  for (let index = 0; index < cart.lineItems.length; ++index) {
	var item = cart.lineItems[index];
    total_cart_items = cart.lineItems[index].quantity + total_cart_items;
	var price = parseFloat(cart.lineItems[index].variant.price.amount || 0);
    cart_total += price * item.quantity;
  }
  cartCount = total_cart_items;
  document.getElementById('cart-count').textContent = cartCount > 0 ? cartCount : '0';

	var subTotalEl = document.querySelector('.shopify-buy__cart__subtotal__price');
	if(subTotalEl){
  subTotalEl.innerHTML =
    cart_total > 0 ? '$'+cart_total.toFixed(2) : '$0.00';
	}
}

function brazeDataCollection() {
  const campaignData = getCampaignData(window.location.href);
  const hachetteJsonLinkingData = document.querySelector('#hachetteJsonLinkingData');
  const marketerData = JSON.parse(hachetteJsonLinkingData.innerText);
  const sourceStr = ' (atc)';
  setBrazeArrayCustomAttr('ISBNs', marketerData.isbn, sourceStr);
  setBrazeArrayCustomAttr('Referral Titles', marketerData.name, sourceStr);
  setBrazeArrayCustomAttr('Referral Authors', marketerData.author, sourceStr, true);
  setBrazeArrayCustomAttr('Product Formats', marketerData.bookFormat.name, sourceStr);
  setBrazeArrayCustomAttr('Series Name', marketerData.series, sourceStr);
  setBrazeArrayCustomAttr('Publisher', marketerData.publisher.name, sourceStr);
  setBrazeArrayCustomAttr('Campaign Name', campaignData.name, sourceStr);
  setBrazeArrayCustomAttr('Campaign Sources', campaignData.source, sourceStr);
  setBrazeArrayCustomAttr('Campaign Media', campaignData.medium, sourceStr);
  setBrazeArrayCustomAttr('Genre', marketerData.genre, sourceStr, true);
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return '';
}

// get the format of the current title.
function getTitleFormat(){
	let titleFormat = '';
	if (window.dataLayer && Array.isArray(window.dataLayer)) {
	  const lastEntry = window.dataLayer[window.dataLayer.length - 1];
	  if (lastEntry && typeof lastEntry === 'object' && 'format' in lastEntry) {
		titleFormat = lastEntry.format;
		console.log(lastEntry.format);
	  }
	}
	return titleFormat;
}

// if cartadd is true in url params, launch cart directly on load.
function launchCartButtonOnLoad() {
   const  titleFormat = getTitleFormat();
  addToCartIsbns.forEach(([k, title]) => { // eslint-disable-line no-unused-vars, consistent-return
    let hbgEndpoint = `https://shopifyapi.hbgusa.com/hbg-shopify-api/api/product/info/Shopify-HbgUsa/${title.isbn}`;
    if (hostname === 'hbg-develop.go-vip.co') {
      hbgEndpoint = `https://shopifyapistg.hbgusa.com/hbg-shopify-api/api/product/info/Shopify-HbgUsa/${title.isbn}`;
    }
    return fetch(hbgEndpoint)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return false;
      })
      .then((response) => {
        if (response && (response.inventoryLevel > 0 || response.preorder === 'Y') && response.show) {
          const { productId } = response; // eslint-disable-line no-shadow
          const { isbn } = response;

          if (response.preorder === 'Y') {
            buttonText = 'Preorder';
          } else {
            buttonText = 'Add to Cart';
          }
          ShopifyBuyInit(productId, isbn, freeShippingAmt); // eslint-disable-line no-use-before-define, max-len
        }
        else if(response && titleFormat == 'Audiobook (via Podcast App)' ){
        const { productId } = response; // eslint-disable-line no-shadow
        const { isbn } = response;
            buttonText = 'Add to Cart';
          ShopifyBuyInit(productId, isbn, freeShippingAmt); // eslint-disable-line no-use-before-define, max-len
		}
        else if(response && (titleFormat == 'Audiobook Download' || titleFormat == 'ebook')  ){
          buttonText = 'Add to Cart';
          ShopifyBuyInit(productId, title.isbn, freeShippingAmt);
          document.getElementById(`product-component-add-to-cart${title.isbn}`).style.display = 'none';
        }
        else if(response && (response.inventoryLevel <= 0 || response.preorder === 'N')) {
          buttonText = 'Add to Cart';
          ShopifyBuyInit(productId, title.isbn, freeShippingAmt);
          document.getElementById(`product-component-add-to-cart${title.isbn}`).style.display = 'none';
        }
      })
      .catch((err) => {
        if (console && console.error) { // eslint-disable-line no-console
          console.error(err); // eslint-disable-line no-console
        }
      });
  });
  return false;
}

function ShopifyBuyInit(productId, isbn, freeShippingAmt) { // eslint-disable-line no-shadow
  const node = document.getElementById(`product-component-add-to-cart${isbn}`);
  let accentColor = '';
  node ? accentColor = getComputedStyle(node).getPropertyValue('--color-accent') : accentColor = '#d93a17'; // eslint-disable-line no-unused-expressions
  const client = ShopifyBuy.buildClient({ // eslint-disable-line no-undef
    domain,
    storefrontAccessToken,
  });
  ShopifyBuy.UI.onReady(client).then((ui) => { // eslint-disable-line no-undef

    const button = document.querySelector('#shopify-cart');
    button.addEventListener('click', (event) => { event.stopPropagation(); ui.openCart()});

    ui.createComponent('product', {
      id: productId,
      node: document.getElementById(`product-component-add-to-cart${isbn}`),
      moneyFormat: '%24%7B%7Bamount%7D%7D',
      options: {
        product: {
          classes: {
            button: 'title-add-to-cart__button title-add-to-cart__button--fill',
          },
          iframe: false,
          DOMEvents: {
            'click .shopify-buy__btn-wrapper': function () {
              const brazeUserEmail = getCookie('brazeUser');
              if (brazeUserEmail !== '') {
                brazeDataCollection();
              }
            },
          },
          styles: {
            product: {
              '@media (min-width: 601px)': {
                'max-width': 'calc(25% - 20px)',
                'margin-left': '20px',
                'margin-bottom': '50px',
              },
            },
            button: addToCartButton,
            quantityInput: {
              'font-size': '16px',
              'padding-top': '16px',
              'padding-bottom': '16px',
            },
          },
          contents: {
            img: false,
            title: false,
            price: false,
            button: isbn !== '000000000000',
          },
          text: {
            button: buttonText,
          },
        },
        productSet: {
          styles: {
            products: {
              '@media (min-width: 601px)': {
                'margin-left': '-20px',
              },
            },
          },
        },
        modalProduct: {
          contents: {
            img: false,
            imgWithCarousel: true,
            button: false,
            buttonWithQuantity: true,
          },
          styles: {
            product: {
              '@media (min-width: 601px)': {
                'max-width': '100%',
                'margin-left': '0px',
                'margin-bottom': '0px',
              },
            },
            button: {
              'font-weight': 'bold',
              'font-size': '16px',
              'padding-top': '16px',
              'padding-bottom': '16px',
              ':hover': {
                'background-color': '#cb2f21',
              },
              'background-color': '#e13425',
              ':focus': {
                'background-color': '#cb2f21',
              },
            },
            quantityInput: {
              'font-size': '16px',
              'padding-top': '16px',
              'padding-bottom': '16px',
            },
          },
          text: {
            button: buttonText,
          },
        },
        option: {},
        cart: {
          iframe: false,
          events: {
              updateItemQuantity: function (cart) {
              updateCartCount(cart);
            },
            beforeRender() {},
            afterRender: function(cart) {
              updateCartCount(cart);
              let freeShippingMsg = '';
              jQuery('.shopify-buy__cart__title') // eslint-disable-line no-undef
                .after(`<div id="freeShippingMsg">${freeShippingMsg}</div>`);
              freeShippingMessage();
              // Set maxlength on the order notes textarea
              const noteTextarea = document.querySelector('.shopify-buy__cart__note__text-area');
              if (noteTextarea) {
                noteTextarea.setAttribute('maxlength', '150');
              }
            },
          },
          text: {
            title: 'Shopping Cart',
            total: 'Subtotal',
            button: 'Checkout',
            noteDescription: 'Add an optional Gift Message (150 character limit)',
          },
          popup: false,
          contents: {
            note: true,
          },
          styles: {
            button: {
              'background-color': accentColor,
              'border-radius': '9999px',
              'font-size': '15px',
              'font-weight': '700',
              'letter-spacing': 'unset',
              'line-height': '1.2',
              padding: '12px 17px',
              ':hover': {
                'background-color': '#000000',
              },
              ':focus': {
                'background-color': '#000000',
              },
            },
          },
        },
        toggle: {
          styles: {
            toggle: {
              'display':'none',
              /*
              'background-color': accentColor,
              'font-weight': '700',
              ':hover': {
                'background-color': '#000000',
                */
              },
            },
          },
        },
      });
  });
}

if (addToCartIsbns.length === 0) {
  ShopifyBuyInit(productId, '000000000000', freeShippingAmt);
  addToCartButton = {
    'font-size': '13px',
    'padding-top': '14.5px',
    'padding-bottom': '14.5px',
    'border-radius': '0px',
    'padding-left': '0px',
    'padding-right': '0px',
  };
  buttonText = '';
  //launchCartButtonOnLoad();
} else {
  addToCartButton = {
    'font-weight': 'bold',
    'font-size': '16px',
    'padding-top': '16px',
    'padding-bottom': '16px',
    ':hover': {
      'background-color': '#cb2f21',
    },
    'background-color': '#e13425',
    ':focus': {
      'background-color': '#cb2f21',
    },
  };
  buttonText = 'Add to Cart';
  //launchCartButtonOnLoad();
}

async function getProductByISBN(isbn) {
  const query = `
	{
	  products(first: 1, query: "metafield:books.isbn:${isbn}") {
		edges {
		  node {
			id
			title
			handle
			description
			publicationDate: metafield(namespace: "custom", key: "publication_date") { value }
			variants(first: 10) {
			  edges {
				node {
				  id
				  sku
				  availableForSale
				}
			  }
			}
		  }
		}
	  }
	}
  `;
console.log('Api Domain is: '+domain);
  const response = await fetch(`https://${domain}/api/2025-10/graphql.json`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": storefrontAccessToken
    },
    body: JSON.stringify({ query })
  });

  const data = await response.json();
  return data;
}

function isPreorder(publicationDate) {
  if (!publicationDate) return false;
 
  const pub = new Date(publicationDate);
  const now = new Date();
  const diffDays = (pub - now) / 86400000;
 
  return diffDays > 0 && diffDays <= 180;
}

function isBeyondPreorder(publicationDate) {
  if (!publicationDate) return false;
 
  const pub = new Date(publicationDate);
  const now = new Date();
  const diffDays = (pub - now) / 86400000;
 
  return diffDays > 180;
}

async function launchAddToCartButton(){
	const url = window.location.pathname;
	const parts = url.split('/').filter(Boolean);
	const isbn = parts[parts.length - 1];
	let responseData = await getProductByISBN(isbn);

	console.log(responseData);

	// Extract product ID and publication date
	const productNode = responseData?.data?.products?.edges?.[0]?.node ?? {};
	const variantNode = productNode?.variants?.edges?.[0]?.node ?? {};
	const productId = (productNode.id ?? "").replace("gid://shopify/Product/", "");
	const publicationDate = productNode?.publicationDate?.value ?? null;
	const availableForSale = variantNode?.availableForSale ?? false;

	console.log('Domain: '+domain);
	console.log('productId:'+productId);
	console.log('publicationDate:'+publicationDate);
	console.log('availableForSale:'+availableForSale);

	if(availableForSale && !isBeyondPreorder(publicationDate)) {
		console.log('If : '+isbn);
		if(isPreorder(publicationDate)===true){
			buttonText = 'Preorder';
		} else {
			buttonText = 'Add to Cart';
		}
		ShopifyBuyInit(productId, isbn, freeShippingAmt);
	} else if(availableForSale === false || isPreorder(publicationDate) === false) {
		console.log('Else : '+isbn);
		buttonText = 'Add to Cart';
	    ShopifyBuyInit(productId, isbn, freeShippingAmt);
	    document.getElementById(`product-component-add-to-cart${isbn}`).style.display = 'none';
	}
}

if (addToCartIsbns.length) {
  launchAddToCartButton();
}
